import { render, staticRenderFns } from "./VideoExercises.vue?vue&type=template&id=609cfbd1&scoped=true"
import script from "./VideoExercises.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoExercises.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VideoExercises.vue?vue&type=style&index=0&id=609cfbd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609cfbd1",
  null
  
)

export default component.exports